import { HighlightKeyword } from '@coveo/headless';

let highlightTag = "<span class='highlight'>";
let highlightEndTag = '</span>';
type HighlightedTextType = {
  value: string;
  highlights: HighlightKeyword[];
};
export function HighlightedText(props: HighlightedTextType) {
  function addHighlight(value: string, highlights: HighlightKeyword[]): string {
    let result: string = value;
    let count: number = 0;
    highlights.forEach((highlight) => {
      result = injectHighlight(
        result,
        highlight.offset + count * (highlightTag.length + highlightEndTag.length),
        highlight.length,
      );
      count++;
    });
    return result;
  }
  function injectHighlight(value: string, offset: number, length: number) {
    let startPos = offset;
    let endPos = offset + length;
    let start = [value.slice(0, startPos), highlightTag].join('');
    let middle = [value.slice(startPos, endPos), highlightEndTag].join('');
    let end = value.slice(endPos);
    return [start, middle, end].join('');
  }
  return (
    <>
      <span
        dangerouslySetInnerHTML={{ __html: addHighlight(props.value, props.highlights) }}
        className="highlightedText"
      />
    </>
  );
}
